<script>
import DOMPurify from 'dompurify';
import ContentBlockView from '@shared/mixins/ContentBlockView';

export default {
  mixins: [ContentBlockView],
  methods: {
    clean(html) {
      return DOMPurify.sanitize(html);
    },
  },
  i18n: {
    messages: {
      en: {
        timeline: {
          no_entries: 'No timeline entries.',
        },
      },
      fr: {
        timeline: {
          no_entries: 'Aucune entrée dans la chronologie.',
        },
      },
    },
  },
};
</script>

<template>
  <div class="compt content is-size-8-mobile">
    <div v-if="!data.entries || !data.entries.length" class="notification is-light">
      {{ $t('timeline.no_entries') }}
    </div>
    <div
      v-else
      class="compt_timeline"
      :class="`is-${data.alignment || 'left'}`"
    >
      <div
        v-for="(entry, k) in data.entries"
        :key="k"
        class="compt_timeline-entry"
        :class="`is-${(k + 1) % 2 === 0 ? 'even' : 'odd'}`"
      >
        <div class="compt_timeline-marker" />
        <div class="compt_timeline-content">
          <p class="is-size-6 is-size-7-mobile mb-2 has-text-primary is-custom">
            {{ entry.checkpoint }}
          </p>
          <div class="box" :class="{'is-inline-block': !entry.isFullWidth}">
            <h2
              v-if="entry.title"
              class="title is-5 is-size-6-mobile"
              :class="{
                'mb-0': !entry.description,
                'mb-3': entry.description,
              }"
              v-html="clean(entry.title)"
            />
            <div
              v-if="entry.description"
              class="break-words"
              v-html="clean(entry.description)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.compt_timeline {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: $grey-lighter;
    z-index: 0;
  }

  .compt_timeline-entry {
    position: relative;
    padding-bottom: 2rem;
    &:last-child { padding-bottom: 0; }
  }

  .compt_timeline-marker {
    position: absolute;
    top: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 4px solid var(--brand-color, $primary);
    background: $white;
    z-index: 1;
  }

  &.is-left {
    &::before { left: 10px; }
    .compt_timeline-marker { left: 0; }
    .compt_timeline-content { margin-left: 48px; }
  }

  &.is-right {
    &::before { right: 10px; }
    .compt_timeline-marker { right: 0; }
    .compt_timeline-content {
      margin-right: 48px;
      text-align: right;
    }
  }

  &.is-alternate {
    display: flex;
    flex-direction: column;

    &::before { left: 50%; margin-left: -2px; }
    .is-even .compt_timeline-marker { left: 0%; transform: translateX(-50%); }
    .is-odd .compt_timeline-marker { right: 0%; transform: translateX(50%); }

    .compt_timeline-entry {
      width: 50%;

      &:nth-child(odd) {
        align-self: flex-start;
        padding-right: 24px;
        .compt_timeline-content { text-align: right; }
      }

      &:nth-child(even) {
        align-self: flex-end;
        padding-left: 24px;
        .compt_timeline-content { text-align: left; }
      }
    }
  }
}
</style>
